export function actualizarPasajeroSolicitud(fila, pasajero) {
  const email = String(pasajero.email || '').trim();
  const emailAnterior = String(fila.pasajero.email || '').trim();
  return {
    ...fila,
    pasajero,
    nombre: [pasajero.nombre, pasajero.primer_apellido, pasajero.segundo_apellido].filter(Boolean).join(' ') || 'Pasajero ' + pasajero.id,
    email_destinatario: email !== emailAnterior ? email : fila.email_destinatario,
    seleccionada: fila.seleccionada && !!email,
  };
}
